module.exports = __webpack_public_path__ + "img/caselist4.1d7a64c2.jpg";